import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import azure from "../../Assets/Projects/azure.jpg";
import unifiedpatents from "../../Assets/Projects/unifiedpatents.jpg";
import pixelpack from "../../Assets/Projects/pixelpack.jpg";
import dxchain from "../../Assets/Projects/dxchain.jpg";
import eth from "../../Assets/Projects/eth.jpg";
import tusimple from "../../Assets/Projects/tusimple.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Works </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={azure}
              title="Azure Storage"
              description="Secure, high-performance, reliable, and scalable cloud storage."
              demoLink="https://azure.microsoft.com/en-us/products/category/storage"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={unifiedpatents}
              title="UnifiedPatents Portal"
              description="Search all PTAB and litigation case dockets, AI-powered patents research and analytics."
              demoLink="https://portal.unifiedpatents.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pixelpack}
              title="Pixel Pack"
              description="Our cutting-edge AI technology transforms vision into pixel-perfect reality products."
              demoLink="https://www.pixelpack.co/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dxchain}
              title="DxChain"
              description="DxChain is committed to building a development platform that supports smart contracts and cross-chain ecosystem, and creates the most powerful public chain for dapps while ensuring security and scalability."
              demoLink="https://www.dxchain.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tusimple}
              title="TuSimple"
              description="Autonomous trucking technologies to make freight transportation safer, more efficient and more environmentally friendly."
              demoLink="https://www.tusimple.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eth}
              title="Ethereum Mining"
              description="Step by step guide to mine Ethereum on AWS."
              demoLink="https://github.com/TianyangChen/EthereumMining"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
